import { useEffect } from 'react'
import {
  collectTrackingData,
  saveTracking,
  getStoredTracking,
  hasAttributionParams,
} from '../lib/tracking'

export default function useTrackingCapture() {
  useEffect(() => {
    if (hasAttributionParams() || !getStoredTracking()) {
      saveTracking(collectTrackingData())
    }
  }, [])
}
